/**
 * TypingDots
 *
 * Three-dot "composing a reply" indicator.
 *
 * Replaces a spinner, which reads as "the page is loading" rather than "a reply
 * is coming". The distinction matters here because the wait is the model
 * thinking, not a fetch.
 *
 * Respects prefers-reduced-motion: the animation is suppressed and the dots
 * render statically rather than disappearing, so the state is still visible.
 */

export function TypingDots({ className = "" }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1 py-1 ${className}`}
      role="status"
      aria-label="Assistant is typing"
      data-testid="streaming-indicator"
    >
      {[0, 150, 300].map((delay) => (
        <span
          key={delay}
          className="h-1.5 w-1.5 rounded-full bg-muted-foreground/70 motion-safe:animate-bounce"
          style={{ animationDelay: `${delay}ms`, animationDuration: "1s" }}
        />
      ))}
    </span>
  );
}
